export default "__VITE_ASSET__ee1275d6__"